import { Redirect } from "expo-router";
import { useTenant } from "@src/features/tenants";
import { View } from "react-native";
import { BackgroundGradient } from "@src/components/BackgroundGradient";

export default function OverviewScreen() {
  const { selectedTenant } = useTenant();

  if (selectedTenant?.id) {
    return <Redirect href={`/tenants/${selectedTenant.id}/overview` as never} />;
  }

  return (
    <BackgroundGradient>
      <View style={{ flex: 1, backgroundColor: "transparent" }} />
    </BackgroundGradient>
  );
}
